import React from 'react'
import Checkbox from '../../Elements/Checkbox'

export default props => {

  const {
    img,
    label,
    iconSize,
    disabled,
    checked,
    onChange
  } = props

  return (
    <div className={`channel-selection-item ${disabled ? 'channel-selection-item-disabled' : ''} mt-2`}>
      <Checkbox onChange={onChange} checked={checked} disabled={disabled}/>
      <img width={iconSize || 25} height={iconSize || 25} src={img} alt="" />
      <label className="channel-selection-item-label">{label}</label>
    </div>
  )

}
